import React from 'react';
import { array, object, bool } from 'prop-types';


import { ParticipantItem } from './participant';
import { ParticipantsListWrapper } from './styles';


export function ParticipantsList({
  users,
  contacts,
  participants,
  wrapperStyles,
  participantIconStyle,
}) {
  return (
    <ParticipantsListWrapper
      wrapperStyles={wrapperStyles}
    >
      {participants.map(userId => (
        <ParticipantItem
          key={`participant-${userId}`}
          participant={users[userId] || contacts[userId]}
          participantIconStyle={{
            ...participantIconStyle,
            ...(wrapperStyles && { marginBottom: '5px' }),
          }}
        />
      ))}
    </ParticipantsListWrapper>
  );
}

ParticipantsList.propTypes = {
  wrapperStyles: bool,
  users: object.isRequired,
  contacts: object.isRequired,
  participantIconStyle: object,
  participants: array.isRequired,
};

ParticipantsList.defaultProps = {
  wrapperStyles: false,
  participantIconStyle: {},
};



// WEBPACK FOOTER //
// ./src/components/notes-simple-list/meeting-notes-list-item/meeting-participants-feedbacks/participants-list/index.js